import { Button as BaseButton, ButtonProps } from 'antd';
import style from './index.module.scss';

type TButton = {
  buttonType?: 'solid' | 'outline';
  buttonStyle?: 'red' | 'common';
} & ButtonProps;

export const Button = ({
  buttonType = 'solid',
  buttonStyle = 'common',
  ...props
}: TButton) => {
  return (
    <BaseButton
      type="default"
      htmlType="button"
      {...props}
      className={`${style.button} ${style[buttonType]} ${props.className} ${
        props.disabled ? style.disabled : ''
      } ${style[buttonStyle]}`}
    />
  );
};
